'use strict';

module.exports = function (angularModule) {
  angularModule.controller('ContactsCtrl', function ($scope, campaign, $state, RGContactUploadService, accountsService, reviewGenService, updateService, adminSearchService, stringService, $stateParams, contactDetailModal, confirmService, getAddContactsLink, locationService, reactContainer) {
    var vm = this;
    vm.contactSearchQuery = adminSearchService.getSearchQuery();
    vm.freshQuery = null;
    vm.accountSelected = false;
    vm.totalContactsInResponse = null;
    vm.state = {
      loading: true,
      updating: false
    };
    vm.contactExportConfig = {};

    vm.pageStrings = stringService.adminStrings();
    vm.updateDetails = updateService.getUpdateDetails();

    vm.accountConfig = {
      required: false,
      accountId: null,
      disableDropdown: false,
      showAccountSelection: false
    };

    vm.updateConfig = {
      entityId: null,
      pageOneResult: true
    };

    vm.contactsPaged = {
      contacts: [],
      total: 0,
      pageSize: 15,
      currentPageNum: 1
    };

    vm.allToggled = false;
    vm.anySelected = false;

    $scope.$watch(() => (locationService.getSelectedGroupId()),(newVal,oldVal) => {
      if(newVal !== oldVal){
        setGroupId(newVal)
        refreshContacts()
      }
    })

    const setGroupId = (id) => {
      vm.groupId = id ? id : locationService.getSelectedGroupId()
    }

    setGroupId()

    vm.assignCampaignModal = function () {
      $('#assignCampaignModal').modal();
    }

    vm.updateAnySelected = function () {
      vm.anySelected = vm.getCheckedIds().length;
    };

    vm.getCheckedIds = function () {
      var checkedIds = _.chain(vm.contactsPaged.contacts)
        .where({checked: true})
        .map(function (item) {
          return item._id.$oid;
        })
        .value();
      return checkedIds;
    };

    vm.toggleEnabled = function (contact) {
      if (contact.enabled) {
        reviewGenService.disableContact(contact._id.$oid).then(function (resp) {
          vm.refreshContacts();
        })
      }
      else {
        reviewGenService.enableContact(contact._id.$oid).then(function (resp) {
          vm.refreshContacts();
        })
      }
    }

    vm.assignCampaign = function (action) {


    }

    vm.toggleAllResults = function () {
      _.each(vm.contactsPaged.contacts, function (item) {
        item.checked = vm.allToggled;
      });
      vm.updateAnySelected();
    }

    /*
     vm.deleteContacts = function(){
     vm.openConfirmDeleteContactsModal();
     }
     */

    vm.bulkDisable = function () {
      reviewGenService.updateStatusContacts(vm.getCheckedIds(), false).then(vm.refreshContacts);
    }

    vm.bulkEnable = function () {
      reviewGenService.updateStatusContacts(vm.getCheckedIds(), true).then(vm.refreshContacts);
    }


    vm.removeContactsModal = function (contact) {
      vm.contact = null;
      if (contact) {
        vm.contact = angular.copy(contact);
      }
      $('#confirmRemoveContactsModal').modal();
    };

    vm.removeContacts = function () {
      var ids = vm.contact ? [vm.contact._id.$oid] : vm.getCheckedIds();
      var actions = [];
      reviewGenService.deleteContacts(ids).then(function (resp) {

        actions.push({action: "delete", count: ids.length});

        var updateInfo = {
          status: "Active",
          type: "contact",
          title: "Contact",
          destinationRole: "manage",
          notificationType: "total",
          actions: actions,
          id: null,
          totalUpdates: ids.length
        }
        updateService.registerSuccessfulUpdate(updateInfo, true);
        $state.reload();
      }, function () {
        vm.state.updating = false;
        vm.contact = null;
      });
    }

    function refreshContacts() {
      vm.state.loading = true;
      vm.allToggled = false;
      vm.contactSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.contactSearchQuery;

      let params = {
        searchTextOpt: vm.contactSearchQuery,
        campaignId: campaign._id.$oid,
        limitOpt: vm.contactsPaged.pageSize,
        cursorOpt: (vm.contactsPaged.currentPageNum - 1) * vm.contactsPaged.pageSize
      }

      if(vm.groupId.search(/^all/)==-1){
        params.groupIdOpt = vm.groupId
      }

      reviewGenService.searchCampaignContacts(params).then(function (response) {
        vm.state.loading = false;

        vm.contactsPaged.contacts = response.data.contacts;
        vm.contactsPaged.total = response.data.count;

        if (vm.updateConfig.entityId) {
          if (_.where(vm.contactsPaged.pagedItems[0], {id: vm.updateConfig.entityId}).length > 0) {
            vm.updateConfig.pageOneResult = true;
          }
        }

        var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId;

        vm.contactExportConfig = {
          export: function () {
            return reviewGenService.exportContacts(accountIdToPass, vm.contactSearchQuery);
          },
          accountId: accountIdToPass,
          contactSearchQuery: vm.contactSearchQuery
        };

        vm.updateAnySelected();

      });
    }

    vm.refreshContacts = () => {
      refreshContacts()
    };

    vm.shareLink = function () {
      getAddContactsLink.openModal(campaign)
    }


    vm.contactsUploadModal = function () {
      RGContactUploadService.open();
    }

    vm.updatePagingState = function () {
      vm.refreshContacts();
    };

    vm.updateContact = function (contact) {
      reviewGenService.updateContact(contact).then(function () {
        vm.refreshContacts();
      });
    };

    vm.deleteContact = function (contact) {
      confirmService.confirm('Confirm Deletion', `Are you sure you want to delete the contact, "${contact.name}"?`, confirmService.DELETE)
        .then(agreed => {
          if (agreed) {
            vm.state.updating = true;
            reviewGenService.deleteContact(contact).then(function () {
              var updateInfo = {
                status: "Active",
                type: "contact",
                title: "Contact",
                destinationRole: "manage",
                notificationType: "detail",
                actions: [{action: "delete"}],
                entity: contact,
                id: contact._id.$oid,
                name: contact.name,
                searchParam: contact.name
              }
              updateService.registerSuccessfulUpdate(updateInfo, true);
              vm.refreshContacts();
            }).finally(() => vm.state.updating = false);
          }
        })
    };

    vm.deleteSelectedContacts = function () {
      let ids = vm.getCheckedIds();
      if (ids.length == 0) {
        return;
      }

      confirmService.confirm('Confirm Bulk Deletion', `Are you sure you want to delete ${ids.length} contacts?`, confirmService.DELETE)
        .then(agreed => {
          if (agreed) {
            vm.state.updating = true;
            reviewGenService.deleteContacts(ids).then(() => {
              vm.refreshContacts();
            }).finally(() => vm.state.updating = false);
          }
        })
    };

    vm.openContactDetailModal = function (contact) {
      contactDetailModal.open(contact);
    };

    vm.isUpdatedItemRow = function (id, entityId) {
      return id == entityId;
    };

    vm.refreshContacts();

  });
};
